module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-1-9cb9db7847cdef4f61498607a953bdfc.svg";